import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M833.935059,1063.32706 C862.848,1233.64235 897.972706,1411.52471 917.398588,1448.11765 C944.956235,1499.95765 1009.44565,1520.06118 1061.39859,1492.50353 C1113.23859,1464.94588 1133.11624,1400.23059 1105.55859,1348.39059 C1086.13271,1311.79765 958.622118,1182.93176 833.935059,1063.32706 Z M790.113882,866.922353 C851.666824,923.844706 1161.01271,1211.73176 1205.39859,1295.53412 C1262.09506,1402.37647 1221.21035,1535.42118 1114.25506,1592.23059 C1081.61506,1609.51059 1046.49035,1617.64235 1011.93035,1617.64235 C933.210353,1617.64235 856.975059,1575.28941 817.558588,1501.08706 C773.172706,1417.28471 708.457412,999.741176 695.920941,916.842353 C692.419765,893.124706 704.165647,869.632941 725.285647,858.564706 C746.631529,847.270588 772.382118,850.545882 790.113882,866.922353 Z M960.045176,281.988706 C1489.40047,281.988706 1920.04518,712.746353 1920.04518,1241.98871 C1920.04518,1319.12753 1911.12282,1395.13694 1893.39106,1467.87106 L1883.00047,1511.01459 L1358.61459,1511.01459 L1358.61459,1398.07341 L1792.87341,1398.07341 C1802.36047,1347.36282 1807.104,1294.95812 1807.104,1241.98871 C1807.104,774.864 1427.05694,394.929882 960.045176,394.929882 C492.920471,394.929882 112.986353,774.864 112.986353,1241.98871 C112.986353,1294.95812 117.729882,1347.36282 127.104,1398.07341 L614.558118,1398.07341 L614.558118,1511.01459 L36.9769412,1511.01459 L26.5863529,1467.87106 C8.96752941,1395.13694 0.0451764706,1319.12753 0.0451764706,1241.98871 C0.0451764706,712.746353 430.689882,281.988706 960.045176,281.988706 Z M1502.592,672.674824 L1582.44141,752.524235 L1469.72612,865.239529 L1389.87671,785.390118 L1502.592,672.674824 Z M417.408,672.674824 L530.123294,785.390118 L450.273882,865.239529 L337.558588,752.524235 L417.408,672.674824 Z M1016.47059,471.312 L1016.47059,630.784941 L903.529412,630.784941 L903.529412,471.312 L1016.47059,471.312 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconDashboardLine = /*#__PURE__*/function (_Component) {
  _inherits(IconDashboardLine, _Component);

  var _super = _createSuper(IconDashboardLine);

  function IconDashboardLine() {
    _classCallCheck(this, IconDashboardLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconDashboardLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDashboard",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconDashboardLine.displayName = "IconDashboardLine";
  return IconDashboardLine;
}(Component);

IconDashboardLine.glyphName = 'dashboard';
IconDashboardLine.variant = 'Line';
IconDashboardLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDashboardLine;
export { IconDashboardLine };